import { useEffect, useState } from "react";
import { useParams } from "react-router";
import React from 'react';
import Api from "../../Api/Api";

import Slider from "../Slider";
import { settingsBanners } from "../../Config/Slider";

import Navbar from "../Navbar";
import LatestTvShow from "./Latest.tvshows";
import TrendingTvShow from "./Trending.tvshows";
import { username } from "../../API";

const TvShowsContaner = () => {
  const [banners, setBanners] = useState([]);
  // const { username } = useParams();
  useEffect(() => {
    const getData = async () => {
      const { show } = await Api.getTvShowsBanners(username);
      console.log(show);
      const banner = show.map((bannerObj) => bannerObj.bannerimage);
      setBanners(banner);
    };
    getData();
  }, [username]);
  return (
    <>
      <Navbar />
      {banners.length && <Slider data={banners} settings={settingsBanners} />}
      <LatestTvShow/>
      <TrendingTvShow/>
    </>
  );
};
export default TvShowsContaner;
